"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.billingInsightSchema = exports.billingRolePolicySchema = exports.billingPermissionsSchema = exports.billingRoleSchema = exports.billingDashboardSummarySchema = exports.simUsageRecordSchema = exports.revenueShareRuleSchema = exports.expenseSchema = exports.purchaseOrderSchema = exports.purchaseOrderItemSchema = exports.purchaseOrderStatusSchema = exports.paymentSchema = exports.paymentStatusSchema = exports.paymentMethodSchema = exports.invoiceSchema = exports.invoiceStatusSchema = exports.invoiceLineItemSchema = exports.invoiceLineItemCategorySchema = exports.subscriptionSchema = exports.billingSubscriptionSeatSchema = exports.billingSubscriptionSeatStatusSchema = exports.billingPlanSchema = exports.subscriptionStatusSchema = exports.billingCycleSchema = exports.billingPlanStatusSchema = exports.billingPlanTierSchema = exports.billingAccountSchema = exports.moneySchema = exports.billingAccountStatusSchema = exports.billingAccountTypeSchema = void 0;
const zod_1 = require("zod");
exports.billingAccountTypeSchema = zod_1.z.union([
    zod_1.z.literal("individual"),
    zod_1.z.literal("fleet"),
    zod_1.z.literal("reseller"),
    zod_1.z.literal("admin"),
]);
exports.billingAccountStatusSchema = zod_1.z.union([
    zod_1.z.literal("active"),
    zod_1.z.literal("suspended"),
    zod_1.z.literal("closed"),
    zod_1.z.literal("draft"),
]);
exports.moneySchema = zod_1.z.object({
    amount: zod_1.z.number(),
    currency: zod_1.z.string().min(3).max(3),
});
exports.billingAccountSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    ownerId: zod_1.z.string(),
    displayName: zod_1.z.string(),
    type: exports.billingAccountTypeSchema,
    status: exports.billingAccountStatusSchema,
    balance: exports.moneySchema,
    creditLimit: exports.moneySchema.optional(),
    autoRenew: zod_1.z.boolean().default(true),
    paymentMethodId: zod_1.z.string().nullable().optional(),
    defaultInvoiceDestination: zod_1.z.string().nullable().optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.billingPlanTierSchema = zod_1.z.union([
    zod_1.z.literal("basic"),
    zod_1.z.literal("safety"),
    zod_1.z.literal("ai"),
    zod_1.z.literal("enterprise"),
    zod_1.z.literal("custom"),
]);
exports.billingPlanStatusSchema = zod_1.z.union([
    zod_1.z.literal("active"),
    zod_1.z.literal("archived"),
    zod_1.z.literal("draft"),
]);
exports.billingCycleSchema = zod_1.z.union([
    zod_1.z.literal("monthly"),
    zod_1.z.literal("quarterly"),
    zod_1.z.literal("biannual"),
    zod_1.z.literal("annual"),
]);
exports.subscriptionStatusSchema = zod_1.z.union([
    zod_1.z.literal("trial"),
    zod_1.z.literal("active"),
    zod_1.z.literal("grace"),
    zod_1.z.literal("suspended"),
    zod_1.z.literal("cancelled"),
]);
exports.billingPlanSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable().optional(),
    tierKey: exports.billingPlanTierSchema,
    status: exports.billingPlanStatusSchema,
    currency: zod_1.z.string().min(3).max(3),
    setupFee: zod_1.z.number().nonnegative(),
    monthlyFee: zod_1.z.number().nonnegative(),
    perVehicleFee: zod_1.z.number().nonnegative(),
    perDeviceFee: zod_1.z.number().nonnegative(),
    maxSeats: zod_1.z.number().int().nonnegative(),
    maxVehicles: zod_1.z.number().int().nonnegative(),
    maxDevices: zod_1.z.number().int().nonnegative(),
    availableBillingCycles: zod_1.z.array(exports.billingCycleSchema).default([]),
    billingCycleAdjustments: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    servicesEnabled: zod_1.z.record(zod_1.z.string(), zod_1.z.boolean()).optional(),
    features: zod_1.z.array(zod_1.z.string()).default([]),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    /** NULL = global SaaS plan; non-null = private org plan. */
    organizationId: zod_1.z.string().nullable().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.billingSubscriptionSeatStatusSchema = zod_1.z.union([
    zod_1.z.literal("active"),
    zod_1.z.literal("revoked"),
]);
exports.billingSubscriptionSeatSchema = zod_1.z.object({
    id: zod_1.z.string(),
    subscriptionId: zod_1.z.string(),
    userId: zod_1.z.string(),
    status: exports.billingSubscriptionSeatStatusSchema,
    assignedAt: zod_1.z.string(),
    revokedAt: zod_1.z.string().nullable().optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.subscriptionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    accountId: zod_1.z.string(),
    planId: zod_1.z.string(),
    planName: zod_1.z.string(),
    tier: exports.billingPlanTierSchema,
    seatCount: zod_1.z.number().int().nonnegative(),
    vehicleCount: zod_1.z.number().int().nonnegative().optional(),
    deviceCount: zod_1.z.number().int().nonnegative().optional(),
    vehicleIds: zod_1.z.array(zod_1.z.string()).optional(),
    deviceIds: zod_1.z.array(zod_1.z.string()).optional(),
    featureFlags: zod_1.z.array(zod_1.z.string()).optional(),
    startDate: zod_1.z.string(),
    endDate: zod_1.z.string().nullable(),
    status: exports.subscriptionStatusSchema,
    recurring: zod_1.z.boolean(),
    autoTopUp: zod_1.z.boolean().default(true),
    trialEndsAt: zod_1.z.string().nullable().optional(),
    nextRenewalAt: zod_1.z.string().nullable(),
    setupFee: zod_1.z.number().nonnegative().optional(),
    monthlyFee: zod_1.z.number().nonnegative().optional(),
    perVehicleFee: zod_1.z.number().nonnegative().optional(),
    perDeviceFee: zod_1.z.number().nonnegative().optional(),
    currency: zod_1.z.string().min(3).max(3).optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.invoiceLineItemCategorySchema = zod_1.z.union([
    zod_1.z.literal("device"),
    zod_1.z.literal("sim"),
    zod_1.z.literal("service"),
    zod_1.z.literal("install"),
    zod_1.z.literal("ai"),
    zod_1.z.literal("sms"),
    zod_1.z.literal("usage"),
    zod_1.z.literal("tax"),
    zod_1.z.literal("credit"),
]);
exports.invoiceLineItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    description: zod_1.z.string(),
    quantity: zod_1.z.number().nonnegative(),
    unitPrice: exports.moneySchema,
    subtotal: exports.moneySchema,
    category: exports.invoiceLineItemCategorySchema,
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
exports.invoiceStatusSchema = zod_1.z.union([
    zod_1.z.literal("draft"),
    zod_1.z.literal("issued"),
    zod_1.z.literal("sent"),
    zod_1.z.literal("partial"),
    zod_1.z.literal("paid"),
    zod_1.z.literal("overdue"),
    zod_1.z.literal("void"),
]);
exports.invoiceSchema = zod_1.z.object({
    id: zod_1.z.string(),
    accountId: zod_1.z.string(),
    number: zod_1.z.string(),
    amountDue: exports.moneySchema,
    amountPaid: exports.moneySchema,
    currency: zod_1.z.string().min(3).max(3),
    periodStart: zod_1.z.string(),
    periodEnd: zod_1.z.string(),
    dueDate: zod_1.z.string(),
    issuedAt: zod_1.z.string().nullable(),
    status: exports.invoiceStatusSchema,
    lineItems: zod_1.z.array(exports.invoiceLineItemSchema),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.paymentMethodSchema = zod_1.z.union([
    zod_1.z.literal("stripe"),
    zod_1.z.literal("paypal"),
    zod_1.z.literal("payfast"),
    zod_1.z.literal("flutterwave"),
    zod_1.z.literal("paystack"),
    zod_1.z.literal("wise"),
    zod_1.z.literal("bank"),
    zod_1.z.literal("bank_transfer"),
    zod_1.z.literal("credit_card"),
    zod_1.z.literal("crypto"),
    zod_1.z.literal("wallet"),
    zod_1.z.literal("mpesa"),
]);
exports.paymentStatusSchema = zod_1.z.union([
    zod_1.z.literal("pending"),
    zod_1.z.literal("success"),
    zod_1.z.literal("failed"),
    zod_1.z.literal("refunded"),
]);
exports.paymentSchema = zod_1.z.object({
    id: zod_1.z.string(),
    invoiceId: zod_1.z.string().nullable().optional(),
    accountId: zod_1.z.string(),
    method: exports.paymentMethodSchema,
    amount: exports.moneySchema,
    status: exports.paymentStatusSchema,
    transactionRef: zod_1.z.string().nullable().optional(),
    processedAt: zod_1.z.string().nullable(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.purchaseOrderStatusSchema = zod_1.z.union([
    zod_1.z.literal("draft"),
    zod_1.z.literal("submitted"),
    zod_1.z.literal("approved"),
    zod_1.z.literal("rejected"),
    zod_1.z.literal("paid"),
]);
exports.purchaseOrderItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    description: zod_1.z.string(),
    quantity: zod_1.z.number().int().nonnegative(),
    unitCost: exports.moneySchema,
    subtotal: exports.moneySchema,
    category: zod_1.z.string(),
});
exports.purchaseOrderSchema = zod_1.z.object({
    id: zod_1.z.string(),
    accountId: zod_1.z.string(),
    supplier: zod_1.z.string(),
    expectedAt: zod_1.z.string().nullable(),
    status: exports.purchaseOrderStatusSchema,
    totalCost: exports.moneySchema,
    currency: zod_1.z.string().min(3).max(3),
    items: zod_1.z.array(exports.purchaseOrderItemSchema),
    approvals: zod_1.z.array(zod_1.z.string()).optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.expenseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    accountId: zod_1.z.string(),
    category: zod_1.z.string(),
    description: zod_1.z.string(),
    amount: exports.moneySchema,
    incurredAt: zod_1.z.string(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.revenueShareRuleSchema = zod_1.z.object({
    id: zod_1.z.string(),
    partnerId: zod_1.z.string(),
    accountId: zod_1.z.string(),
    displayName: zod_1.z.string(),
    shareType: zod_1.z.union([
        zod_1.z.literal("percentage"),
        zod_1.z.literal("flat"),
        zod_1.z.literal("dynamic"),
    ]),
    percentage: zod_1.z.number().min(0).max(1).nullable().optional(),
    flatAmount: exports.moneySchema.nullable().optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    active: zod_1.z.boolean(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.simUsageRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    accountId: zod_1.z.string(),
    simId: zod_1.z.string(),
    periodStart: zod_1.z.string(),
    periodEnd: zod_1.z.string(),
    dataUsedMb: zod_1.z.number().nonnegative(),
    smsUsed: zod_1.z.number().nonnegative(),
    sessionCount: zod_1.z.number().nonnegative(),
    roamingCost: exports.moneySchema.optional(),
    totalCost: exports.moneySchema,
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.billingDashboardSummarySchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    mrr: exports.moneySchema,
    arr: exports.moneySchema.optional(),
    outstanding: exports.moneySchema,
    trials: zod_1.z.number().int().nonnegative(),
    gracePeriodTenants: zod_1.z.number().int().nonnegative(),
    suspendedTenants: zod_1.z.number().int().nonnegative(),
    churnForecast: zod_1.z.number().min(0).max(1),
    collectionRate: zod_1.z.number().min(0).max(1),
    generatedAt: zod_1.z.string(),
});
exports.billingRoleSchema = zod_1.z.union([
    zod_1.z.literal("end_user"),
    zod_1.z.literal("fleet_owner"),
    zod_1.z.literal("reseller"),
    zod_1.z.literal("admin"),
    zod_1.z.literal("super_admin"),
]);
exports.billingPermissionsSchema = zod_1.z.object({
    canViewInvoices: zod_1.z.boolean(),
    canPayInvoices: zod_1.z.boolean(),
    canManageSubscriptions: zod_1.z.boolean(),
    canConfigurePricing: zod_1.z.boolean(),
    canManageRevenueShare: zod_1.z.boolean(),
    canAccessReports: zod_1.z.boolean(),
});
exports.billingRolePolicySchema = zod_1.z.object({
    role: exports.billingRoleSchema,
    permissions: exports.billingPermissionsSchema,
});
exports.billingInsightSchema = zod_1.z.object({
    id: zod_1.z.string(),
    accountId: zod_1.z.string(),
    category: zod_1.z.union([zod_1.z.literal("revenue"), zod_1.z.literal("retention"), zod_1.z.literal("collections"), zod_1.z.literal("usage"), zod_1.z.literal("risk")]),
    title: zod_1.z.string(),
    summary: zod_1.z.string(),
    confidence: zod_1.z.number().min(0).max(1),
    trend: zod_1.z.union([zod_1.z.literal("up"), zod_1.z.literal("down"), zod_1.z.literal("steady")]),
    impact: exports.moneySchema.optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    generatedAt: zod_1.z.string(),
});
